import { useQuery } from '@apollo/client';

import { GetArticlesQuery, GetArticlesQueryVariables } from '../../../../__generated__/graphql';
import GetArticles from '../articlesQuery.gql';

const defaultArticlesQueryVariables: GetArticlesQueryVariables = {
  after: null,
  categoryId: null,
  first: 6,
  notIn: undefined,
  tagId: null,
};

export const useGetArticlesQuery = (variables: GetArticlesQueryVariables) => {
  const data = useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticles, {
    variables: {
      ...defaultArticlesQueryVariables,
      ...variables,
    },
  });

  // fetch the next page ahead of time
  useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticles, {
    variables: {
      ...defaultArticlesQueryVariables,
      ...variables,
      after: data.data?.posts?.pageInfo.endCursor ?? null,
    },
  });

  return data;
};
